import { ref } from 'vue'

// 全局状态
const showErrorState = ref(false)
const errorTitle = ref('No Access')
const errorDescription = ref('You do not have permission to access this page.')

/**
 * 错误状态管理 composable
 * 用于在应用中显示全局错误状态页面
 */
export function useErrorState() {
  /**
   * 设置错误状态
   * @param show - 是否显示错误状态
   * @param title - 错误标题（可选）
   * @param description - 错误描述（可选）
   */
  const setErrorState = (
    show: boolean,
    title: string = 'No Access',
    description: string = 'You do not have permission to access this page.'
  ) => {
    showErrorState.value = show
    if (title) errorTitle.value = title
    if (description) errorDescription.value = description
  }

  /**
   * 显示错误状态
   * @param title - 错误标题（可选）
   * @param description - 错误描述（可选）
   */
  const showError = (
    title: string = 'No Access',
    description: string = 'You do not have permission to access this page.'
  ) => {
    setErrorState(true, title, description)
  }

  /**
   * 隐藏错误状态
   */
  const hideError = () => {
    setErrorState(false)
  }

  return {
    showErrorState,
    errorTitle,
    errorDescription,
    setErrorState,
    showError,
    hideError,
  }
}
